export const OPTION_COLORS: Record<string, Record<string, string>> = {
    escalation: {
        "9b85283b-e5b3-463a-95fd-339cccfc6188": "#DB6C0B",
        "8a1d4743-d381-4cdc-909a-6cdd3ff39169": "#E53935",
        "7c9685b5-485c-41bc-97f1-3079c0afce65": "#B71C1C",
    },
    tags: {
        "Tag A": "purple",
        "Tag B": "orange",
        "Tag C": "teal",
    },
};

export const DefaultOptionColor = "#000";